import { PushpinOutlined } from "@ant-design/icons";

export default function PinIndicator({ message }) {
  if (!message) return null;

  return (
    <div className="str-chat__message-team-pin-indicator">
      <PushpinOutlined />
      {message.pinned_by
        ? `Pinned by ${message.pinned_by?.name || message.pinned_by?.id}`
        : "Message pinned"}
    </div>
  );
}
